<template>
  <!-- 总分馆 -->
  <div class="headBranch-container">
    <div class="headBranch-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/headBranch-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">总分馆解决方案</h2>
          <p class="banner-desc">借助博库云图书管理平台</p>
          <p class="banner-desc">与图书馆现有管理系统组成“双系统架构”</p>
          <p class="banner-desc">既能保证图书馆原有数据的完整性和安全性</p>
          <p class="banner-desc">又能实现图书馆总馆与分馆的通借通还流通体系</p>
        </div>
      </div>
    </div>
    <!-- slogan -->
    <div class="headBranch-container-slogan">
      <p>博库总分馆解决方案借助博库云图书管理平台</p>
      <p>可以最大限度地整合并优化图书资源配置，实现公共图书馆服务效益最大化</p>
    </div>
    <!-- 总分示意图 -->
    <div class="headBranch-container-pic">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-showPic.png"
        alt=""
      />
    </div>
    <!-- 管理模式 -->
    <div class="headBranch-container-manageMode">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-manageMode.png"
        alt=""
      />
    </div>
    <!-- 功能与优势 -->
    <div class="headBranch-container-features">
      <h2 class="headBranch-container-features-title title-common">
        功能与优势
      </h2>
      <ul class="headBranch-container-features-content">
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-item1.png"
            alt=""
          />
          <p>不依赖专用接口、不依赖专用网络，无需为每个分馆开通帐号。</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-item2.png"
            alt=""
          />
          <p>自适应有线/wifi/4G网络环境，通过平台数据交换完成流通。</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-item3.png"
            alt=""
          />
          <p>
            分馆与总馆互相独立，减轻总馆系统负载，降低系统运维的复杂性，保证总馆系统高可靠性运转。
          </p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-item4.png"
            alt=""
          />
          <p>扩展性好，根据总分馆需求，理论上支持无限分馆数量的扩展。</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-item5.png"
            alt=""
          />
          <p>分馆流通系统与总馆系统数据打通，统一汇聚到总馆大数据平台。</p>
        </li>
      </ul>
    </div>
    <!-- 总分馆大数据平台 -->
    <div class="headBranch-container-bigData">
      <h2 class="headBranch-container-bigData-title title-common">
        总分馆大数据平台
      </h2>
      <div class="headBranch-container-bigData-content">
        <p>
          总分馆大数据可显示总馆借还书实时统计
          以及全馆人流统计数据，同时可查看分馆数据
          能够快速掌握总馆大数据和分馆区域数据对比
        </p>
        <img
          src="https://image.bookgo.com.cn/bgOfficial/headBranch/headBranch-data.png"
          alt=""
        />
      </div>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libHeadBranch.scss";
</style>
